import React from 'react';
import ReactDOM from 'react-dom';
import '@src/styles/App.less';
import '@src/styles/index.scss';
import reportWebVitals from './reportWebVitals';
import {persist, store} from '@src/store/store';
import {Provider} from 'react-redux';
import App from '@src/App';
import {PersistGate} from 'redux-persist/integration/react';
import {ApplicationInsightsProvider, LanguageContextProvider, RecaptchaContextProvider,} from '@src/context';
import 'unfonts.css'

export const Index = () => (
    <ApplicationInsightsProvider>
        <RecaptchaContextProvider>
            <LanguageContextProvider>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persist}>
                        <App />
                    </PersistGate>
                </Provider>
            </LanguageContextProvider>
        </RecaptchaContextProvider>
    </ApplicationInsightsProvider>
);

const root = document.getElementById('root');

ReactDOM.render(<Index />, root);

reportWebVitals();
